import styled from "@emotion/styled";
import React, { useState, useEffect } from "react";

import Button from "~/components/buttons/Button";

import { useOptionsContext } from "~/context/OptionsContext";

import { getSingleton } from "~/utilities/localStorageItem";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.palette.darkBlue};
    color: ${({ theme }) => theme.palette.white};
    padding: ${({ theme }) =>
        `${theme.layout.gutter} ${theme.layout.largeGutter}`};
    max-width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: ${({ theme }) => theme.zIndex.cookieNotice};

    a {
        color: ${({ theme }) => theme.palette.white};
        text-decoration: underline;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobileLandscape}) {
        left: ${({ theme }) => theme.layout.gutter};
        max-width: 400px;
    }
`;

const Content = styled.div``;

const ButtonWrapper = styled.div``;

const CookieNotice = () => {
    const [isOpen, setIsOpen] = useState(false);

    const localStorageItem = getSingleton("cookieNotice");
    const hasSeenCookieNotice = localStorageItem.has();
    const { cookieNotice } = useOptionsContext();

    const accept = () => {
        localStorageItem.add("true");
        setIsOpen(false);
    };

    useEffect(() => {
        if (!hasSeenCookieNotice) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [hasSeenCookieNotice]);

    return cookieNotice && !hasSeenCookieNotice && isOpen ? (
        <Wrapper>
            <Content>{sanitizeAndParseHTML(cookieNotice)}</Content>
            <ButtonWrapper>
                <Button onClick={accept}>I Accept</Button>
            </ButtonWrapper>
        </Wrapper>
    ) : null;
};

export default CookieNotice;
